<template>
    <component
        :is="linkConfig.component"
        v-if="linkConfig.validation"
        v-bind="linkConfig.attrs"
        class="prismic-link"
    >
        <slot />
    </component>
</template>

<script>
export default {
    props: {
        link: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isWeblink() {
            return this.link && this.link.link_type === 'Web';
        },
        isPrismicLink() {
            return this.link 
                && this.link.link_type === 'Document' 
                && this.$validateContentRelationship(this.link);
        },
        resolvedLink() {
            if (this.isWeblink) {
                return this.link.url;
            }
            if (this.isPrismicLink) {
                return this.$prismic.linkResolver(this.link);
            }
            return null;
        },
        linkConfig() {
            return {
                validation: this.isWeblink || this.isPrismicLink,
                component: this.isWeblink 
                    ? 'a' 
                    : 'nuxt-link',
                attrs: this.isWeblink 
                    ? {
                        href: this.resolvedLink,
                        target: '_blank'
                    }
                    : {
                        to: this.resolvedLink,
                        target: '_self',
                    }
            };
        }
    }
};
</script>